import { calculateHeightToBottom } from '@client/utils/dom';

export const insightsSection = {
  element: '.activity-details .report-tour',
  popover: {
    title: 'Campaign Insights',
    description:
      'Dive into recipient interactions with your campaign. View activity history, live replays, and audience breakdowns.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const element = document.querySelector('.activity-details .report-tour');
      const heightToBottom = calculateHeightToBottom(element);

      element.style.height = `${heightToBottom}px`;
    }
  }
};
